import styled from "styled-components";
import { OnboardingButtonLink } from "./OnboardingButton";
import { LabelMedium } from "./OnboardingTypography";

const HelpLinkContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const OnboardingHelpLink = () => {
  return (
    <HelpLinkContainer>
      <LabelMedium>
        Ta kontakt med oss på{" "}
        <a 
          href="mailto:kundepost@kred.no"
          style={{
            color: '#000000',
            textDecoration: 'underline',
            fontWeight: '600',
            fontSize: '18px',
            fontFamily: 'Manrope, sans-serif'
          }}
        >
          kundepost@kred.no
        </a>{" "}
        eller ring{" "}
        <a 
          href="tel:02456"
          style={{
            color: '#000000',
            textDecoration: 'underline',
            fontWeight: '600',
            fontSize: '18px',
            fontFamily: 'Manrope, sans-serif'
          }}
        >
          02456
        </a>{" "}
        dersom du trenger hjelp.
      </LabelMedium>
    </HelpLinkContainer>
  );
};

export default OnboardingHelpLink;

